import { c as _c } from "react/compiler-runtime";
import { SelectionIcon } from "@flat-ui";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { toggleItemSelection } from "@utils/array-utils";

/**
 * Hook to get the menu options for mobile view of groups.
 * @returns An array of menu item options for groups.
 */
export function useGroupMenuOptionsMobile() {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  let t0;
  if ($[0] !== dispatch || $[1] !== selectedRowIds) {
    t0 = [{
      label: "Select group",
      Icon: SelectionIcon,
      onSelect: group => {
        const newSelectedRowIds = toggleItemSelection(selectedRowIds, group.id);
        dispatch(setInitialFetchingItems(newSelectedRowIds));
      }
    }];
    $[0] = dispatch;
    $[1] = selectedRowIds;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const menuOptions = t0;
  return menuOptions;
}